import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["ampmButton", "color", "fieldError", "inputFormat", "inputRef", "isLargeScreen", "onChangAmPm", "onChange", "onChangesetWeekOfDay", "placeholder", "renderInput", "shouldDisableDate", "textFieldProps", "value", "weekOfDayButton", "wrapper"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TextField from '@mui/material/TextField';
import { useMediaQuery } from '@mui/material';
import TAGPickerFilterTabContent from './TAGPickerFilterTabContent';
import TAGDateCalendar from './TAGDateCalendar';
import TAGPickerWrapper from './TAGPickerWrapper';
import TAGPickerTabs from './TAGPickerTabs';
import { disableSunday } from './TAGPicker.type';
import { PickersDay, pickersDayClasses } from '@mui/lab';
import { transformedColor } from '../../../constants/themehelper';
/**
 * This component contains the main date picker
 * example :
 *      <TAGDatePicker
      value={value}
      onChange={newValue => {
        setValue(newValue)
      }}
    />
*/

var TAGDatePicker = function TAGDatePicker(_ref) {
  var ampmButton = _ref.ampmButton,
      color = _ref.color,
      _ref$fieldError = _ref.fieldError,
      fieldError = _ref$fieldError === void 0 ? false : _ref$fieldError,
      inputFormat = _ref.inputFormat,
      inputRef = _ref.inputRef,
      isLargeScreen = _ref.isLargeScreen,
      onChangAmPm = _ref.onChangAmPm,
      onChange = _ref.onChange,
      onChangesetWeekOfDay = _ref.onChangesetWeekOfDay,
      placeholder = _ref.placeholder,
      renderInput = _ref.renderInput,
      shouldDisableDate = _ref.shouldDisableDate,
      textFieldProps = _ref.textFieldProps,
      value = _ref.value,
      weekOfDayButton = _ref.weekOfDayButton,
      _ref$wrapper = _ref.wrapper,
      wrapper = _ref$wrapper === void 0 ? 'Dialog' : _ref$wrapper,
      props = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState(new Date()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      tempValue = _React$useState2[0],
      setTempValue = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      open = _React$useState4[0],
      setOpen = _React$useState4[1]; // const screenMatches = useMediaQuery('(min-width:500px)')


  var screenMatches = isLargeScreen !== undefined ? isLargeScreen : useMediaQuery('(min-width:500px)');

  var onOpen = function onOpen() {
    return setOpen(true);
  };

  var onClose = function onClose() {
    return setOpen(false);
  };

  var onClear = function onClear() {
    return onChange(new Date());
  };

  var onAccept = function onAccept() {
    onChange(tempValue);
    setOpen(false);
  };

  var onSetToday = function onSetToday() {
    onChange(new Date());
    setOpen(false);
  };

  var onChangeTempValue = function onChangeTempValue(newValue) {
    return setTempValue(newValue);
  };

  var tabData = [{
    label: 'date',
    content: React.createElement(TAGDateCalendar, {
      color: color,
      displayStaticWrapperAs: 'desktop',
      tempValue: tempValue,
      onChange: onChangeTempValue
    })
  }, {
    label: 'filter',
    content: React.createElement(TAGPickerFilterTabContent, {
      color: color,
      ampmButton: ampmButton,
      onChangAmPm: onChangAmPm,
      onChangesetWeekOfDay: onChangesetWeekOfDay,
      weekOfDayButton: weekOfDayButton,
      sx: {
        padding: '20px'
      }
    })
  }];

  var renderDayPickerDay = function renderDayPickerDay(_date, _selectedDates, pickersDayProps) {
    return React.createElement(PickersDay, _objectSpread(_objectSpread({}, pickersDayProps), {}, {
      color: color,
      sx: _defineProperty({}, "&&.".concat(pickersDayClasses.selected), {
        backgroundColor: transformedColor(color)
      })
    }));
  };

  var renderInputField = function renderInputField(params) {
    return React.createElement(TextField, _objectSpread(_objectSpread(_objectSpread({}, textFieldProps), {}, {
      fullWidth: true
    }, params), {}, {
      "data-test": "date-picker-textfield",
      error: fieldError,
      placeholder: placeholder
    }));
  };

  return React.createElement(LocalizationProvider, {
    dateAdapter: AdapterDateFns
  }, React.createElement(DesktopDatePicker, _objectSpread({
    ref: inputRef,
    renderDay: renderDayPickerDay,
    inputFormat: inputFormat || 'iii MMM dd, yyyy',
    shouldDisableDate: shouldDisableDate || disableSunday,
    value: value,
    open: wrapper === 'Popper' && open && screenMatches,
    onChange: onChange,
    onClose: onClose,
    onOpen: onOpen,
    renderInput: renderInput !== undefined ? renderInput : renderInputField
  }, props)), React.createElement(TAGPickerWrapper, {
    color: color,
    open: open,
    screenMatch: screenMatches,
    onOpen: onOpen,
    onClose: onClose,
    onAccept: onAccept,
    onSetToday: onSetToday,
    onClear: onClear,
    drawerChildren: React.createElement(TAGPickerTabs, {
      tabData: tabData
    }),
    wrapper: wrapper
  }, React.createElement(TAGDateCalendar, {
    color: color,
    displayStaticWrapperAs: 'mobile',
    tempValue: tempValue,
    onChange: onChangeTempValue
  })));
};

export default TAGDatePicker;